import type { DeepPartial } from '@luna/utils-ts';
import type { CardsFeatureConfig } from '@shared/cards-config';

import {
    AuthorizedCardHeaderDetailsFeatureConfig,
    CardActivationFeatureConfig,
    CardBankHeaderFeatureConfig,
    CardDeliveryFeatureConfig,
    CardLimitsChangeFeatureConfig,
    CardsBankListFeatureConfig,
    CardsCreditCardFeesFeatureConfig,
    CardsCreditLimitChangeFeatureConfig,
    CardsSettingsCardDetailsFeatureConfig,
    CreditCardContentBoxFeatureConfig,
    CreditSharedFeatureConfig,
    DebitCardContentBoxFeatureConfig,
    DisplayPinFeatureConfig,
    OrderReplacementCardFeatureConfig,
} from './featureConfig';

export const cards: DeepPartial<CardsFeatureConfig> = {
    isNativeAliasChangeAllowed: true,
    overview: {
        VIRTUAL_CREDIT: {
            MAIN: {
                hide: false,
            },
            AUTHORIZED: {
                hide: false,
            },
            AUTHORIZED_STANDALONE: {
                hide: false,
            },
        },
        VIRTUAL_DEBIT: {
            MAIN: {
                hide: false,
            },
            AUTHORIZED: {
                hide: false,
            },
            AUTHORIZED_STANDALONE: {
                hide: false,
            },
        },
    },
    bank: {
        showAsProduct: true,
        asProduct: true,
        showVirtualCardOrderSection: true,
    },
    credit: CreditSharedFeatureConfig.CZ,
    shared: {
        functions: {
            tpLimits: {
                drivenByFeaturesAndFlags: true,
                permanentAlwaysActive: true,
            },
        },
        menu: {
            separateAuthorized: false,
        },
        settings: {
            sos: {
                preferFlag: true,
                loadDetails: true,
            },
            reissue: {
                reorder: {
                    displayAsCard: true,
                },
                lock: {
                    confirmationLanguages: ['cs', 'en'],
                    doubleFetchEnabled: true,
                    doubleFetchTimeout: 5000,
                },
                unlock: {
                    doubleFetchEnabled: true,
                    doubleFetchTimeout: 5000,
                },
            },
        },
    },
    components: {
        cardDelivery: CardDeliveryFeatureConfig.CZ,
        cardServices: {
            replacementCardV2: {
                enabled: true,
                emailConfirmation: true,
            },
            orderReplacementCard: OrderReplacementCardFeatureConfig.CZ,
        },
        cardServicesList: {
            displayPin: DisplayPinFeatureConfig.CZ,
        },
        limitsChange: CardLimitsChangeFeatureConfig.CZ,
        creditCardLimitChange: CardsCreditLimitChangeFeatureConfig.CZ,
        cardsList: CardsBankListFeatureConfig.CZ,
        bankCardHeader: CardBankHeaderFeatureConfig.CZ,
        cardActivation: CardActivationFeatureConfig.CZ,
        cardFees: CardsCreditCardFeesFeatureConfig.CZ,
        settings: {
            cardDetails: CardsSettingsCardDetailsFeatureConfig.CZ,
        },
        authorizedCardHeaderDetails: AuthorizedCardHeaderDetailsFeatureConfig.CZ,
        creditCardContentBox: CreditCardContentBoxFeatureConfig.CZ,
        debitCardContentBox: DebitCardContentBoxFeatureConfig.CZ,
    },
    statements: {
        signed: true,
    },
};
